$(document).ready(function () {
    $(document).trigger('lastDocumentReady');
});
$(document).on("lastDocumentReady", function () {
    setTimeout(function () {
        $('#loader-block').fadeOut();
    }, 500);
});


// WEBPACK FOOTER //
// ./resources/assets/themes/default/js/loader.js